export default "__VITE_ASSET__BUkbNUxT__"